export const AUTH_CONTEXT_INITIAL_STATE = {
  result: false,
  expiresAt: 0,
  userId: null,
};
